export default "__VITE_ASSET__65ab155c__"